// extracted by mini-css-extract-plugin
export default {"appFooter":"PageFooter_appFooter__uingk"};